import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { take } from 'rxjs/operators';
import { Program, Standard } from '../../compliance/models';
import { ProgramService, StandardService } from '../../compliance/services';
import { TransactionType } from '../../compliance/enums';

@Component({
  selector: 'kt-workflow-add-standard',
  templateUrl: './workflow-add-standard.component.html',
})
export class WorkflowAddStandardComponent implements OnInit {
  form: FormGroup;
  getProgramAutocomplete = this.programService.searchProgram.bind(this.programService);
  getStandardAutocomplete = this.standardService.searchStandard.bind(this.standardService);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<WorkflowAddStandardComponent>,
    private formBuilder: FormBuilder,
    private programService: ProgramService,
    private standardService: StandardService,
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      workflowId: ['', Validators.required],
      program: [null, Validators.required],
      standards: [[], Validators.required],
    });
  }

  onWorkflowChange(event): void {
    const workflowId = event.value;

    this.standardService
      .getStandardListByTransaction(workflowId, TransactionType.WORKFLOW_EVENT)
      .subscribe((res) => {
        this.form.get('standards').patchValue(res);
      });
  }

  formatProgramOption(program: Program): string {
    return program ? program.name : '';
  }

  onProgramChange(program: Program): void {
    this.form.get('program').patchValue(program);
    this.getStandardAutocomplete = this.standardService.searchStandard.bind(
      this.standardService,
      program.id,
      false,
    );
  }

  formatStandardOption(standard: Standard): string {
    return standard
      ? `${standard.standard_reference}<small class="text-muted ml-4">${
          standard.program ? standard.program.name : ''
        }</small>`
      : '';
  }

  formatNewStandard(standard: Standard): Standard {
    return standard;
  }

  onStandardChange(standards: Standard[]): void {
    this.form.get('standards').patchValue(standards);
  }

  isInvalid(name: string): boolean {
    const field = this.form.get(name);

    return field.touched && field.invalid;
  }

  getErrorMessage(name: string): string {
    return `${name} field is required`;
  }

  onClose(event): void {
    event.stopPropagation();

    this.dialogRef.close();
  }

  onSubmit(event): void {
    event.stopPropagation();

    const workflowId = this.form.get('workflowId').value;
    const standards = this.form.get('standards').value;
    const standardIds =
      standards && standards.length ? standards.map((standard) => standard.id) : [];

    this.standardService
      .setStandardListByTransaction(workflowId, TransactionType.WORKFLOW_EVENT, standardIds)
      .pipe(take(1))
      .subscribe(() => this.dialogRef.close(true));
  }
}
